import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const KARAR_DURUMLAR = [
  { value: 'beklemede',  label: 'Beklemede' },
  { value: 'devam',      label: 'Devam Ediyor' },
  { value: 'tamamlandi', label: 'Tamamlandı' },
  { value: 'iptal',      label: 'İptal' },
];
const DURUM_RENK: Record<string, string> = {
  beklemede: '#95a5a6', devam: '#3498db', tamamlandi: '#27ae60', iptal: '#7f8c8d',
};

const emptyKarar = {
  karar_metni: '', sorumlu_personel_id: '', sorumlu_birim_id: '',
  son_tarih: '', durum: 'beklemede', konu_id: '', yeni_konu_ac: false, yeni_konu_baslik: '',
};

// ── Ağaç Katılımcı Seçici ──────────────────────────────────────────────────

function PersonelAgaci({
  agac, seciliIds, onToggle,
}: {
  agac: any[];
  seciliIds: Set<number>;
  onToggle: (p: any) => void;
}) {
  const [acikKollar, setAcikKollar] = useState<Set<string>>(() => new Set());
  const [acikGruplar, setAcikGruplar] = useState<Set<string>>(() => new Set());
  const [ara, setAra] = useState('');

  const araKelime = ara.trim().toLowerCase();

  const kolToggle = (key: string) =>
    setAcikKollar(s => { const n = new Set(s); n.has(key) ? n.delete(key) : n.add(key); return n; });
  const grupToggle = (key: string) =>
    setAcikGruplar(s => { const n = new Set(s); n.has(key) ? n.delete(key) : n.add(key); return n; });

  // Arama açıksa tüm kollar otomatik açılır
  const kolAcik = (key: string) => araKelime ? true : acikKollar.has(key);
  const grupAcik = (key: string) => araKelime ? true : acikGruplar.has(key);

  const filtrePersonel = (pList: any[]) =>
    araKelime ? pList.filter(p => p.ad_soyad.toLowerCase().includes(araKelime)) : pList;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Arama */}
      <div style={{ padding: '0 0 10px' }}>
        <input
          value={ara} onChange={e => setAra(e.target.value)}
          placeholder="🔍 Personel ara..."
          style={{ width: '100%', padding: '6px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12, boxSizing: 'border-box' }}
        />
      </div>

      <div style={{ flex: 1, overflowY: 'auto' }}>
        {agac.map(kol => {
          const kolKey = kol.tip;
          const kolGoster = kolAcik(kolKey);
          // Kolda arama sonucu var mı?
          const kolSonuc = araKelime && kol.gruplar.some((g: any) => filtrePersonel(g.personeller || []).length > 0);
          if (araKelime && !kolSonuc) return null;

          return (
            <div key={kolKey} style={{ marginBottom: 4 }}>
              {/* Kol başlığı */}
              <div
                onClick={() => kolToggle(kolKey)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6, padding: '7px 8px',
                  background: '#1a3c5e', color: '#fff', borderRadius: 7, cursor: 'pointer',
                  userSelect: 'none', fontSize: 12, fontWeight: 700,
                }}
              >
                <span style={{ fontSize: 14, transition: 'transform .15s', display: 'inline-block',
                  transform: kolGoster ? 'rotate(90deg)' : 'rotate(0deg)' }}>▶</span>
                <span>{kol.ikon} {kol.ad}</span>
                <span style={{ marginLeft: 'auto', fontSize: 10, opacity: .7 }}>
                  {kol.gruplar.reduce((s: number, g: any) => s + (g.personeller?.length || 0), 0)} kişi
                </span>
              </div>

              {/* Gruplar */}
              {kolGoster && (
                <div style={{ marginLeft: 12, marginTop: 2 }}>
                  {kol.gruplar.map((grup: any) => {
                    const fPers = filtrePersonel(grup.personeller || []);
                    if (araKelime && fPers.length === 0) return null;
                    const grupKey = `${kolKey}_${grup.ad}`;
                    const grupGoster = grupAcik(grupKey);
                    const seciliSayisi = fPers.filter((p: any) => seciliIds.has(p.id)).length;

                    return (
                      <div key={grupKey} style={{ marginBottom: 2 }}>
                        {/* Grup başlığı */}
                        <div
                          onClick={() => grupToggle(grupKey)}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 6, padding: '5px 8px',
                            background: '#f0f4f8', borderRadius: 6, cursor: 'pointer',
                            userSelect: 'none', fontSize: 12,
                          }}
                        >
                          <span style={{ fontSize: 11, color: '#888', transition: 'transform .15s', display: 'inline-block',
                            transform: grupGoster ? 'rotate(90deg)' : 'rotate(0deg)' }}>▶</span>
                          <span>{grup.ikon || '🏢'}</span>
                          <span style={{ fontWeight: 600, color: '#333' }}>{grup.ad}</span>
                          <span style={{ marginLeft: 'auto', fontSize: 10, color: '#888' }}>
                            {fPers.length} kişi
                            {seciliSayisi > 0 && (
                              <span style={{ marginLeft: 6, background: '#1a5276', color: '#fff',
                                borderRadius: 8, padding: '1px 6px' }}>{seciliSayisi} ✓</span>
                            )}
                          </span>
                        </div>

                        {/* Personel listesi */}
                        {grupGoster && (
                          <div style={{ marginLeft: 16, marginTop: 2 }}>
                            {fPers.map((p: any) => {
                              const secildi = seciliIds.has(p.id);
                              return (
                                <label
                                  key={p.id}
                                  style={{
                                    display: 'flex', alignItems: 'center', gap: 8,
                                    padding: '4px 8px', borderRadius: 5, cursor: 'pointer',
                                    background: secildi ? '#eaf2fb' : 'transparent',
                                    border: `1px solid ${secildi ? '#1a5276' : 'transparent'}`,
                                    marginBottom: 2,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={secildi}
                                    onChange={() => onToggle(p)}
                                    style={{ accentColor: '#1a5276' }}
                                  />
                                  <span style={{ fontSize: 12, color: '#333' }}>{p.ad_soyad}</span>
                                  {p.birim_adi && p.birim_adi !== grup.ad && (
                                    <span style={{ fontSize: 10, color: '#999', marginLeft: 'auto' }}>{p.birim_adi}</span>
                                  )}
                                </label>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Ana Sayfa ──────────────────────────────────────────────────────────────

export default function ToplantıDetay() {
  const { id } = useParams();
  const nav = useNavigate();
  const [toplanti,    setToplanti]    = useState<any>(null);
  const [personelAgac, setPersonelAgac] = useState<any[]>([]);
  const [birimler,    setBirimler]    = useState<any[]>([]);
  const [konular,     setKonular]     = useState<any[]>([]);
  const [katModal,    setKatModal]    = useState(false);
  const [kararModal,  setKararModal]  = useState(false);
  const [seciliKarar, setSeciliKarar] = useState<any>(null);
  const [kararForm,   setKararForm]   = useState<any>({ ...emptyKarar });
  // katılımcı seçimi: personel id → {id, ad_soyad}
  const [seciliIds,   setSeciliIds]   = useState<Set<number>>(new Set());
  const [katDiger,    setKatDiger]    = useState('');
  const [hata,        setHata]        = useState('');
  const [yuk,         setYuk]         = useState(false);
  const [dosyaYuk,    setDosyaYuk]    = useState(false);
  const dosyaRef = useRef<HTMLInputElement>(null);

  // personel id → {ad_soyad, birim_adi} lookup (tüm ağaçtan düzleştirme)
  const personelLookup = useMemo(() => {
    const m: Record<number, any> = {};
    personelAgac.forEach(kol =>
      kol.gruplar?.forEach((g: any) =>
        g.personeller?.forEach((p: any) => { m[p.id] = p; })
      )
    );
    return m;
  }, [personelAgac]);

  useEffect(() => {
    fetch(`${API}/api/is-takip/referans/personel-agac`, { headers: hdr() })
      .then(r => r.json()).then(d => setPersonelAgac(Array.isArray(d) ? d : [])).catch(() => {});
    fetch(`${API}/api/is-takip/referans/birimler`, { headers: hdr() })
      .then(r => r.json()).then(d => setBirimler(Array.isArray(d) ? d : [])).catch(() => {});
    fetch(`${API}/api/is-takip/konular`, { headers: hdr() })
      .then(r => r.json()).then(d => setKonular(Array.isArray(d) ? d : [])).catch(() => {});
    yukle();
  }, [id]);

  const yukle = () => {
    fetch(`${API}/api/is-takip/toplantilar/${id}`, { headers: hdr() })
      .then(r => r.json()).then(d => {
        setToplanti(d);
      }).catch(() => {});
  };

  // Katılımcı modalını aç — mevcut katılımcıları seçili işaretle
  const katilimciModalAc = () => {
    const ids = new Set<number>(
      (toplanti?.katilimcilar || [])
        .filter((k: any) => !k.diger && k.personel_id)
        .map((k: any) => k.personel_id as number)
    );
    setSeciliIds(ids);
    setKatDiger(
      (toplanti?.katilimcilar || [])
        .filter((k: any) => k.diger)
        .map((k: any) => k.ad_soyad)
        .join(', ')
    );
    setKatModal(true);
  };

  const personelToggle = (p: any) => {
    setSeciliIds(prev => {
      const n = new Set(prev);
      n.has(p.id) ? n.delete(p.id) : n.add(p.id);
      return n;
    });
  };

  const katilimciKaydet = async () => {
    setYuk(true);
    const liste: any[] = Array.from(seciliIds).map(pid => {
      const p = personelLookup[pid];
      return { personel_id: pid, ad_soyad: p?.ad_soyad || String(pid), birim: p?.birim_adi || null, diger: false };
    });
    if (katDiger.trim()) {
      katDiger.split(',').map(s => s.trim()).filter(Boolean).forEach(ad =>
        liste.push({ personel_id: null, ad_soyad: ad, birim: null, diger: true })
      );
    }
    await fetch(`${API}/api/is-takip/toplantilar/${id}/katilimcilar/toplu`, {
      method: 'POST', headers: { ...hdr(), 'Content-Type': 'application/json' },
      body: JSON.stringify(liste),
    });
    setYuk(false); setKatModal(false); yukle();
  };

  // ── Karar ──
  const kararAc = (kr?: any) => {
    setSeciliKarar(kr || null);
    setKararForm(kr ? {
      karar_metni: kr.karar_metni,
      sorumlu_personel_id: kr.sorumlu_personel_id ? String(kr.sorumlu_personel_id) : '',
      sorumlu_birim_id: kr.sorumlu_birim_id ? String(kr.sorumlu_birim_id) : '',
      son_tarih: kr.son_tarih || '', durum: kr.durum,
      konu_id: kr.konu_id ? String(kr.konu_id) : '',
      yeni_konu_ac: false, yeni_konu_baslik: '',
    } : { ...emptyKarar });
    setHata(''); setKararModal(true);
  };

  const kararKaydet = async () => {
    if (!kararForm.karar_metni.trim()) { setHata('Karar metni zorunludur'); return; }
    if (kararForm.yeni_konu_ac && !kararForm.yeni_konu_baslik.trim()) { setHata('Yeni konu başlığı zorunludur'); return; }
    setHata(''); setYuk(true);
    const body = {
      karar_metni:         kararForm.karar_metni,
      sorumlu_personel_id: kararForm.sorumlu_personel_id ? Number(kararForm.sorumlu_personel_id) : null,
      sorumlu_birim_id:    kararForm.sorumlu_birim_id    ? Number(kararForm.sorumlu_birim_id)    : null,
      son_tarih:           kararForm.son_tarih || null,
      durum:               kararForm.durum,
      konu_id:             kararForm.konu_id && !kararForm.yeni_konu_ac ? Number(kararForm.konu_id) : null,
      yeni_konu_ac:        kararForm.yeni_konu_ac,
      yeni_konu_baslik:    kararForm.yeni_konu_baslik || null,
    };
    try {
      if (seciliKarar) {
        await fetch(`${API}/api/is-takip/kararlar/${seciliKarar.id}`, {
          method: 'PUT', headers: { ...hdr(), 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      } else {
        await fetch(`${API}/api/is-takip/toplantilar/${id}/kararlar`, {
          method: 'POST', headers: { ...hdr(), 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      }
      setKararModal(false); yukle();
    } catch { setHata('Kayıt hatası'); }
    finally { setYuk(false); }
  };

  const kararSil = async (krid: number) => {
    if (!window.confirm('Bu karar silinsin mi?')) return;
    await fetch(`${API}/api/is-takip/kararlar/${krid}`, { method: 'DELETE', headers: hdr() });
    yukle();
  };

  const kararDurum = async (krid: number, durum: string, karar: any) => {
    await fetch(`${API}/api/is-takip/kararlar/${krid}`, {
      method: 'PUT', headers: { ...hdr(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ karar_metni: karar.karar_metni, durum }),
    }); yukle();
  };

  // ── Dosya ──
  const dosyaYukle = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0]; if (!f) return;
    setDosyaYuk(true);
    const fd = new FormData(); fd.append('dosya', f);
    await fetch(`${API}/api/is-takip/dosya-yukle/toplanti/${id}`, { method: 'POST', headers: hdr(), body: fd });
    setDosyaYuk(false); yukle();
    if (dosyaRef.current) dosyaRef.current.value = '';
  };

  const dosyaSil = async (did: number) => {
    if (!window.confirm('Dosya silinsin mi?')) return;
    await fetch(`${API}/api/is-takip/dosyalar/${did}`, { method: 'DELETE', headers: hdr() });
    yukle();
  };

  const inp = (f: string) => (e: any) => setKararForm((v: any) => ({ ...v, [f]: e.target.value }));

  if (!toplanti) return <div style={{ padding: 32, color: '#888' }}>Yükleniyor...</div>;

  const mevcut_katilimcilar: any[] = toplanti.katilimcilar || [];
  const diger_katilimcilar = mevcut_katilimcilar.filter((k: any) => k.diger);

  return (
    <div style={{ padding: '20px 24px', maxWidth: 960 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <button onClick={() => nav('/toplanti')} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#888' }}>←</button>
        <div>
          <h2 style={{ margin: 0, fontSize: 17, color: '#1a3c5e' }}>{toplanti.baslik}</h2>
          <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
            {toplanti.tarih?.slice(0, 16)?.replace('T', ' ')}
            {toplanti.yer && ` · ${toplanti.yer}`}
          </div>
        </div>
      </div>

      {toplanti.notlar && (
        <div style={{ background: '#f8f9fa', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#555' }}>
          {toplanti.notlar}
        </div>
      )}

      {/* Katılımcılar */}
      <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <span style={{ fontWeight: 700, fontSize: 14, color: '#1a3c5e' }}>
            Katılımcılar ({mevcut_katilimcilar.length})
          </span>
          <button onClick={katilimciModalAc}
            style={{ background: 'none', border: '1px solid #ddd', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>
            Düzenle
          </button>
        </div>
        {mevcut_katilimcilar.length === 0 && <div style={{ color: '#bbb', fontSize: 12 }}>Katılımcı girilmemiş</div>}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {mevcut_katilimcilar.map((k: any) => (
            <span key={k.id} style={{
              background: k.diger ? '#fff3e0' : '#eaf2fb',
              color: k.diger ? '#e67e22' : '#1a5276',
              fontSize: 11, padding: '4px 10px', borderRadius: 20,
            }}>
              {k.ad_soyad}{k.birim ? ` (${k.birim})` : ''}{k.diger ? ' *' : ''}
            </span>
          ))}
        </div>
        {diger_katilimcilar.length > 0 && (
          <div style={{ fontSize: 10, color: '#bbb', marginTop: 6 }}>* Sistemde kayıtlı olmayan katılımcı</div>
        )}
      </div>

      {/* Kararlar */}
      <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <span style={{ fontWeight: 700, fontSize: 14, color: '#1a3c5e' }}>Kararlar ({toplanti.kararlar?.length || 0})</span>
          <button onClick={() => kararAc()}
            style={{ background: '#1a5276', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', cursor: 'pointer', fontSize: 12 }}>
            + Karar Ekle
          </button>
        </div>
        {toplanti.kararlar?.length === 0 && <div style={{ color: '#bbb', fontSize: 12, padding: '8px 0' }}>Henüz karar eklenmemiş</div>}
        {toplanti.kararlar?.map((kr: any, i: number) => {
          const gecikti = kr.son_tarih && new Date(kr.son_tarih) < new Date() && kr.durum !== 'tamamlandi';
          return (
            <div key={kr.id} style={{ border: `1px solid ${gecikti ? '#fcc' : '#eee'}`, borderRadius: 8, padding: '10px 12px', marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
                    <span style={{ fontSize: 11, color: '#888', minWidth: 20 }}>{i + 1}.</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{kr.karar_metni}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 10, fontSize: 11, color: '#888', marginTop: 4, flexWrap: 'wrap', paddingLeft: 28 }}>
                    {kr.sorumlu_personel_ad && <span>👤 {kr.sorumlu_personel_ad}</span>}
                    {kr.sorumlu_birim_ad    && <span>🏢 {kr.sorumlu_birim_ad}</span>}
                    {kr.son_tarih && <span style={{ color: gecikti ? '#e74c3c' : '#888' }}>📅 {kr.son_tarih}{gecikti ? ' ⚠️' : ''}</span>}
                    {kr.konu_id && (
                      <span onClick={() => nav(`/is-takip/${kr.konu_id}`)}
                        style={{ color: '#1a5276', cursor: 'pointer', textDecoration: 'underline' }}>
                        📁 İş Konusuna Git
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <select value={kr.durum} onChange={e => kararDurum(kr.id, e.target.value, kr)}
                    style={{ fontSize: 11, padding: '2px 6px', borderRadius: 5, border: `1px solid ${DURUM_RENK[kr.durum] || '#ccc'}`, color: DURUM_RENK[kr.durum] }}>
                    {KARAR_DURUMLAR.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                  </select>
                  <button onClick={() => kararAc(kr)} style={{ background: 'none', border: '1px solid #ddd', borderRadius: 5, padding: '2px 7px', cursor: 'pointer', fontSize: 11 }}>✎</button>
                  <button onClick={() => kararSil(kr.id)} style={{ background: 'none', border: '1px solid #fcc', borderRadius: 5, padding: '2px 7px', cursor: 'pointer', fontSize: 11, color: '#e74c3c' }}>✕</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Dosyalar */}
      <div style={{ background: '#fff', borderRadius: 10, padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <span style={{ fontWeight: 700, fontSize: 14, color: '#1a3c5e' }}>Ekler ({toplanti.dosyalar?.length || 0})</span>
          <label style={{ background: '#1a5276', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', cursor: 'pointer', fontSize: 12 }}>
            {dosyaYuk ? 'Yükleniyor...' : '+ Dosya Ekle'}
            <input ref={dosyaRef} type="file" style={{ display: 'none' }} onChange={dosyaYukle} />
          </label>
        </div>
        {toplanti.dosyalar?.length === 0 && <div style={{ color: '#bbb', fontSize: 12 }}>Ek dosya yok</div>}
        {toplanti.dosyalar?.map((d: any) => (
          <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f5f5f5', padding: '6px 0' }}>
            <a href={`${API}${d.url}`} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#1a5276', textDecoration: 'none' }}>
              📎 {d.dosya_adi}
            </a>
            <div style={{ display: 'flex', gap: 8, fontSize: 11, color: '#888', alignItems: 'center' }}>
              <span>{d.yukleyen_ad}</span>
              <span>{d.yuklenme_tarihi?.slice(0, 10)}</span>
              <button onClick={() => dosyaSil(d.id)} style={{ background: 'none', border: '1px solid #fcc', borderRadius: 5, padding: '2px 6px', cursor: 'pointer', fontSize: 11, color: '#e74c3c' }}>Sil</button>
            </div>
          </div>
        ))}
      </div>

      {/* ── Katılımcı Modalı ── */}
      {katModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{
            background: '#fff', borderRadius: 12, width: 580, height: '80vh',
            display: 'flex', flexDirection: 'column', boxShadow: '0 8px 40px rgba(0,0,0,.25)', overflow: 'hidden',
          }}>
            {/* Modal başlık */}
            <div style={{ padding: '16px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1a3c5e' }}>Katılımcıları Düzenle</div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                  {seciliIds.size} personel seçildi
                </div>
              </div>
              {/* Seçilenlerin özeti */}
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', maxWidth: 200, justifyContent: 'flex-end' }}>
                {Array.from(seciliIds).slice(0, 4).map(pid => (
                  <span key={pid} style={{ fontSize: 10, background: '#eaf2fb', color: '#1a5276', padding: '2px 7px', borderRadius: 10 }}>
                    {personelLookup[pid]?.ad_soyad || `#${pid}`}
                  </span>
                ))}
                {seciliIds.size > 4 && (
                  <span style={{ fontSize: 10, color: '#888' }}>+{seciliIds.size - 4} daha</span>
                )}
              </div>
            </div>

            {/* Ağaç */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '12px 16px' }}>
              <PersonelAgaci agac={personelAgac} seciliIds={seciliIds} onToggle={personelToggle} />
            </div>

            {/* Diğer katılımcılar */}
            <div style={{ padding: '10px 16px', borderTop: '1px solid #eee', background: '#fafafa' }}>
              <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>
                Diğer Katılımcılar <span style={{ color: '#aaa' }}>(sistemde kayıtlı olmayanlar, virgülle ayırın)</span>
              </label>
              <input
                value={katDiger} onChange={e => setKatDiger(e.target.value)}
                placeholder="Ali Veli, Ayşe Kaya, ..."
                style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }}
              />
            </div>

            {/* Butonlar */}
            <div style={{ padding: '12px 16px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <button onClick={() => setSeciliIds(new Set())}
                style={{ background: 'none', border: 'none', color: '#e74c3c', fontSize: 12, cursor: 'pointer' }}>
                Seçimi Temizle
              </button>
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setKatModal(false)}
                  style={{ padding: '7px 18px', borderRadius: 6, border: '1px solid #ddd', cursor: 'pointer', fontSize: 13 }}>
                  İptal
                </button>
                <button onClick={katilimciKaydet} disabled={yuk}
                  style={{ padding: '7px 18px', borderRadius: 6, background: '#1a5276', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, opacity: yuk ? .6 : 1 }}>
                  {yuk ? 'Kaydediliyor...' : `Kaydet (${seciliIds.size} kişi)`}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Karar Modalı ── */}
      {kararModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 26, width: 520, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,.2)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 15 }}>{seciliKarar ? 'Karar Düzenle' : 'Karar Ekle'}</h3>

            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Karar Metni *</label>
            <textarea value={kararForm.karar_metni} onChange={inp('karar_metni')} rows={3}
              style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', marginBottom: 12, boxSizing: 'border-box', fontSize: 13, resize: 'vertical' }} />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Sorumlu Personel</label>
                <select value={kararForm.sorumlu_personel_id} onChange={inp('sorumlu_personel_id')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Seçiniz</option>
                  {/* Ağaçtan düzleştirilmiş liste */}
                  {personelAgac.flatMap((kol: any) =>
                    kol.gruplar?.flatMap((g: any) =>
                      (g.personeller || []).map((p: any) => (
                        <option key={p.id} value={p.id}>{p.ad_soyad}</option>
                      ))
                    ) || []
                  )}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Sorumlu Birim</label>
                <select value={kararForm.sorumlu_birim_id} onChange={inp('sorumlu_birim_id')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Seçiniz</option>
                  {birimler.map((b: any) => <option key={b.id} value={b.id}>{b.ad}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Son Tarih</label>
                <input type="date" value={kararForm.son_tarih} onChange={inp('son_tarih')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Durum</label>
                <select value={kararForm.durum} onChange={inp('durum')}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  {KARAR_DURUMLAR.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                </select>
              </div>
            </div>

            <div style={{ background: '#f8f9fa', borderRadius: 8, padding: '10px 12px', marginBottom: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8 }}>İş Konusu Bağlantısı</div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, marginBottom: 8, cursor: 'pointer' }}>
                <input type="checkbox" checked={kararForm.yeni_konu_ac}
                  onChange={e => setKararForm((f: any) => ({ ...f, yeni_konu_ac: e.target.checked, konu_id: '' }))} />
                Bu karardan yeni iş konusu aç
              </label>
              {kararForm.yeni_konu_ac ? (
                <input value={kararForm.yeni_konu_baslik} onChange={inp('yeni_konu_baslik')}
                  placeholder="Yeni konu başlığı..."
                  style={{ width: '100%', padding: '6px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
              ) : (
                <select value={kararForm.konu_id} onChange={inp('konu_id')}
                  style={{ width: '100%', padding: '6px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Mevcut konuya bağlama (opsiyonel)</option>
                  {konular.map((k: any) => <option key={k.id} value={k.id}>{k.baslik}</option>)}
                </select>
              )}
            </div>

            {hata && <div style={{ color: '#e74c3c', fontSize: 12, marginBottom: 8 }}>{hata}</div>}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setKararModal(false)} style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #ddd', cursor: 'pointer', fontSize: 13 }}>İptal</button>
              <button onClick={kararKaydet} disabled={yuk}
                style={{ padding: '6px 16px', borderRadius: 6, background: '#1a5276', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, opacity: yuk ? .6 : 1 }}>
                {yuk ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
